const getPageRoutes = state => {
  const { pages = new Map() } = state
  return [...pages.keys()].map(key => ({ path: `/${key}/`, exact: true }))
}

export default getPageRoutes
